import React from "react";
import { connect } from "react-redux";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Datetime from "react-datetime";
import Axios from "axios";
import { pushProfile, proccessUpload } from "api/Profile/index";
import { pushLoader } from "actions/main";
import avatar from "../../assets/img/faces/no-profile.png";
import ImageUpload from "components/CustomUpload/ImageUpload.jsx";
import ImageUploader from "react-images-upload";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import _ from "lodash";

import moment from "moment";
import { fetchCompanyAll } from "../../api/company";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import Config from "../../config/";
import { withRouter } from "react-router-dom";
const ROOT_URL = Config.rooturl;

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: localStorage.getItem("name"),
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
      picture_url: localStorage.getItem("picture_url"),
      profile: "",
      job: localStorage.getItem("job"),
      description: localStorage.getItem("description"),
      email: localStorage.getItem("email"),
      multipleSelect: [],
      simpleSelect: localStorage.getItem("gender"),
      brithday: moment(localStorage.getItem("brithday")),
      gender: localStorage.getItem("gender"),
      password: "",
      passwordcheck: "",
      pictures: [],
      file_upload: "",
      msgerror: "",
      company_code: localStorage.getItem("company_code"),
      search: "",
      companyList: [],
      new: "",
      showPassword: false,
      showNewPass: false,
      company_name: ""
    };
  }

  UNSAFE_componentWillMount() {
    this.props.pushLoader(false);
    console.log("=========");
    console.log(this.state.picture_url);
    if (this.state.picture_url == "") {
      this.setState({ picture_url: avatar });
    }
    console.log("==========");
    this.getCompanyList();
  }

  getCompanyList = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchCompanyAll()
      .then(response => {
        if (response != null) {
          let newvalue = _.find(response.data.results, {
            company_code: localStorage.getItem("company_code")
          });
          let namecom = newvalue.company_name;
          this.setState({
            companyList: response.data.results,
            new: newvalue,
            company_name: namecom
          });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };
  onDrop = picture => {
    this.setState({
      pictures: this.state.pictures.concat(picture)
    });
  };

  handleMultiple = event => {
    console.log(event.target.value);
    this.setState({ multipleSelect: event.target.value });
  };

  handleSimple = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  getBirthday = event => {
    console.log(moment(event._d, "YYYY MMMM DD").format("YYYY-MM-DD"));
    this.setState({ brithday: moment(event._d) });
  };

  handleChangeName = e => {
    console.log({ name: e.target.value });
    this.setState({ name: e.target.value });
  };

  handleChangeJob = e => {
    this.setState({ job: e.target.value });
  };

  handleChangeDescription = e => {
    this.setState({ description: e.target.value });
  };

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    console.log(event.target.files[0]);
  };

  handleUpdateProfile = () => {
    let picture_url = "";

    console.log(this.state.file_upload);

    this.setState({ msgerror: "" });

    let urlupload;

    // if (this.state.file_upload != "") {
    //   proccessUpload(this.state.file_upload)
    //     .then(response => {
    //       picture_url = response.data.url;
    pushProfile(
      this.state.id,
      this.state.name,
      this.state.gender,
      moment(this.state.brithday, "YYYY MMMM DD").format("YYYY-MM-DD"),
      this.state.description,
      this.state.job,
      picture_url,
      this.state.company_code
    )
      .then(response => {
        if (response != null) {
          console.log("berhasil");
        }
      })
      .catch(error => {
        this.props.history.push("/pages/login#logout");
        console.log("tidak berhasil");
      });
    //     })
    //     .catch(error => {
    //       this.props.history.push("/pages/login#logout");
    //       console.log(error);
    //     });
    // } else {
    //   pushProfile(
    //     this.state.id,
    //     this.state.name,
    //     this.state.gender,
    //     moment(this.state.brithday, "YYYY MMMM DD").format("YYYY-MM-DD"),
    //     this.state.description,
    //     this.state.job,
    //     pass,
    //     picture_url,
    //     this.state.company_code
    //   )
    //     .then(response => {
    //       if (response != null) {
    //         console.log("berhasil");
    //       }
    //     })
    //     .catch(error => {
    //       this.props.history.push("/pages/login#logout");
    //       console.log("tidak berhasil");
    //     });
    // }
  };

  handleUpdatePassword = () => {
    const data = {
      name: this.state.name,
      email: this.state.email,
      gender: this.state.gender,
      brithday: moment(this.state.brithday, "YYYY MMMM DD").format(
        "YYYY-MM-DD"
      ),
      description: this.state.description,
      job: this.state.job
    };
    console.log(
      moment(this.state.brithday, "YYYY MMMM DD").format("YYYY-MM-DD")
    );
    pushProfile(
      this.state.id,
      this.state.name,
      this.state.gender,
      moment(this.state.brithday, "YYYY MMMM DD").format("YYYY-MM-DD"),
      this.state.description,
      this.state.job,
      this.state.company_code
    )
      .then(response => {
        if (response != null) {
          console.log("berhasil");
        }
      })
      .catch(error => {
        this.props.history.push("/pages/login#logout");
        console.log("tidak berhasil");
      });
  };

  handleChangePassword = event => {
    this.setState({ password: event.target.value });
  };

  handleChangePasswordCheck = event => {
    this.setState({ passwordcheck: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleClickShowNewPass = () => {
    this.setState({ showNewPass: !this.state.showNewPass });
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Edit Profile - <small>Complete your profile</small>
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  {/*<GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Company (disabled)"
                      id="company-disabled"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />
                  </GridItem>*/}
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Email address"
                      id="email-address"
                      inputProps={{
                        value: this.state.email
                      }}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="name"
                      inputProps={{
                        value: this.state.name,
                        onChange: this.handleChangeName
                      }}
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    hidden={
                      localStorage.getItem("userlevel") == 2 ? true : false
                    }
                  >
                    <TextField
                      id="company-name"
                      label="Company Name"
                      value={this.state.company_name}
                      fullWidth
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    hidden={
                      localStorage.getItem("userlevel") == 2 ? false : true
                    }
                  >
                    <Autocomplete
                      value={this.state.new}
                      onChange={(event, newValue) => {
                        this.setState({ new: newValue });
                      }}
                      inputValue={this.state.search}
                      onInputChange={(event, newInputValue) => {
                        let valuenya = newInputValue.split(") ");
                        this.setState({
                          search: newInputValue,
                          company_code: valuenya[0].slice(1)
                        });
                      }}
                      id="company-search"
                      options={this.state.companyList}
                      getOptionLabel={option =>
                        "(" + option.company_code + ") " + option.company_name
                      }
                      renderInput={params => (
                        <TextField
                          {...params}
                          label="Company Name"
                          //variant="filled"
                          style={{ width: "100%", paddingBottom: 1 }}
                        />
                      )}
                    />
                  </GridItem>
                </GridContainer>
                <br />
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        Choose Gender
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={this.state.simpleSelect}
                        onChange={this.handleSimple}
                        inputProps={{
                          name: "simpleSelect",
                          id: "simple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem
                          }}
                        >
                          Choose Gender
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="male"
                        >
                          Male
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="female"
                        >
                          Female
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <br />
                    <InputLabel className={classes.label}>
                      Date Birthday
                    </InputLabel>
                    <br />
                    <FormControl fullWidth>
                      <Datetime
                        timeFormat={false}
                        dateFormat="LL"
                        onChange={this.getBirthday}
                        inputProps={{
                          placeholder: "Date Picker Here"
                        }}
                        value={this.state.brithday}
                      />
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <InputLabel style={{ color: "#AAAAAA" }}>
                      About me
                    </InputLabel>
                    <CustomInput
                      labelText="description"
                      id="about-me"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 5,
                        value: this.state.description,
                        onChange: this.handleChangeDescription
                      }}
                    />
                  </GridItem>
                </GridContainer>
                {/* <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Change Password"
                      inputProps={{
                        type: this.state.showPassword ? "text" : "password",
                        value: this.state.password,
                        onChange: this.handleChangePassword,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={this.handleClickShowPassword}
                              onMouseDown={this.handleMouseDownPassword}
                            >
                              {this.state.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      id="password"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer> */}
                {/* <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Confirm Password"
                      inputProps={{
                        type: this.state.showNewPass ? "text" : "password",
                        value: this.state.passwordcheck,
                        onChange: this.handleChangePasswordCheck,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={this.handleClickShowNewPass}
                              onMouseDown={this.handleMouseDownPassword}
                            >
                              {this.state.showNewPass ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      id="password"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer> */}
                <font color="red">{this.state.msgerror}</font>
                <Button
                  color="rose"
                  className={classes.updateProfileButton}
                  onClick={this.handleUpdateProfile}
                >
                  Update Profile
                </Button>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
          {/* <GridItem xs={12} sm={12} md={4}>
            <Card profile>
              <CardBody profile>
                <CardAvatar profile>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <img src={this.state.picture_url} alt="..." />
                  </a>
                </CardAvatar>

                <Button variant="contained" component="label">
                  <CustomInput
                    inputProps={{
                      type: "file",
                      onChange: this.handleFileUpload
                    }}
                  />
                </Button>

                <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
                <CustomInput
                  labelText="job"
                  className={classes.cardCategory}
                  inputProps={{
                    value: this.state.job,
                    onChange: this.handleChangeJob
                  }}
                  id="job"
                  formControlProps={{
                    fullWidth: true
                  }}
                />
                <h4 className={classes.cardTitle}>{this.state.name}</h4>
                <p className={classes.description} />
              </CardBody>
            </Card>
          </GridItem> */}
        </GridContainer>
      </div>
    );
  }
}

UserProfile.propTypes = {
  pushLoader
};

function mapStateToProps(state) {
  return {
    blocking: state.loader
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLoader }
  )(withStyles(userProfileStyles)(UserProfile))
);
